import { BaseActionObject, StateNodeConfig } from "xstate4"
import { Context, Transitions } from "../../types"

export const breaksToggleState: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  on: {
    TOGGLE_BREAK_BEFORE_SECTION: {
      target: "toggle_break_before_section_transition"
    },
    TOGGLE_BREAK_AFTER_SECTION: {
      target: "toggle_break_after_section_transition"
    },
    TOGGLE_BREAK_BEFORE_LESSON: {
      target: "toggle_break_before_lesson_transition"
    },
    TOGGLE_BREAK_AFTER_LESSON: {
      target: "toggle_break_after_lesson_transition"
    }
  }
}
